import { render, staticRenderFns } from "./SampleUploader.vue?vue&type=template&id=779131ee"
import script from "./SampleUploader.vue?vue&type=script&lang=js"
export * from "./SampleUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779131ee')) {
      api.createRecord('779131ee', component.options)
    } else {
      api.reload('779131ee', component.options)
    }
    module.hot.accept("./SampleUploader.vue?vue&type=template&id=779131ee", function () {
      api.rerender('779131ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleUploader.vue"
export default component.exports